import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import type { RealtimeNotificationToastPayload } from "./registration-review-notifications.service";

/**
 * Servicio simple para emitir toasts desde cualquier componente del backoffice.
 * `DefaultLayoutComponent` se suscribe al subject y renderiza los toasts con
 * el mismo `ToasterComponent` que usa el servicio de notificaciones en tiempo real.
 */
@Injectable({ providedIn: "root" })
export class AppToastService {
  readonly toastRequest$ = new Subject<RealtimeNotificationToastPayload>();

  success(title: string, body: string, options?: Partial<RealtimeNotificationToastPayload>): void {
    this.toastRequest$.next({
      title,
      body,
      color: "success",
      iconName: "cilCheckCircle",
      ...options,
    });
  }

  info(title: string, body: string, options?: Partial<RealtimeNotificationToastPayload>): void {
    this.toastRequest$.next({
      title,
      body,
      color: "info",
      iconName: "cilInfo",
      ...options,
    });
  }

  error(title: string, body: string, options?: Partial<RealtimeNotificationToastPayload>): void {
    this.toastRequest$.next({
      title,
      body,
      color: "danger",
      iconName: "cilWarning",
      ...options,
    });
  }
}
